export default class TenantConfigurationConstants {
    public static readonly DatabaseNamePrefix = "BC_Client_"
}